module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/sockjs-client/lib/transport/browser/eventsource.js
// module id = ../../../../sockjs-client/lib/transport/browser/eventsource.js
// module chunks = 19